import {createAsyncThunk} from "@reduxjs/toolkit";
import AuthService from "../../entity/auth/AuthService";

export const getUserInfo = createAsyncThunk('profile/getUserInfo', async (_, {}) => {
        const resp = await AuthService.getUserInfo()
        return resp.body
})
